<div class="main flex flex-column align-items-center justify-center"><h1>当前角色无权限进入该页面</h1><a-button type="primary" @click="goBack">返回首页</a-button></div>